/* eslint-disable camelcase */
import GiftCertificateSelector from 'components/pages/checkout/GiftCertificateSelector';
import Heading from 'components/text/Heading';
import LoadingIcon from 'assets/icons/Loading';
import Payment from 'components/pages/checkout/CheckoutView/Payment';
import PropTypes from 'prop-types';
import React from 'react';
import ThemeButton from 'components/buttons/ThemeButton';
import styled from 'libs/styled';
import { useGiftCertificateContext } from 'libs/GiftCertificate/GiftCertificateContext';

const Div = styled('div')``;

const StepButton = styled(ThemeButton)`
    width: 100%;
    font-size: 16px;
`;

const GiftCertificateContent = ({ data }) => {
    const { gift_certificate_setup: giftCertificate } = data;
    const {
        button_label_edit: buttonLabelEdit,
        button_label_procced: buttonLabelProcced,
        flexible_gift_certificate_placeholder: flexibleGiftCertPlaceholder,
        heading: certificateHeading,
        maximum_gift_certificate_value: maxValue,
        minimum_gift_certificate_value: minValue,
    } = giftCertificate;

    const {
        editSelectedGiftCertificate,
        giftCertCheckoutStep,
        giftCerts,
        onSelect,
        proceedToCheckout,
        readyToProceed,
        sectionLoading,
        selectedGiftCert,
    } = useGiftCertificateContext();

    return (
        <>
            <Div display="flex" flexDirection="column" mb="40px">
                {certificateHeading.text && (
                    <Heading size="md" as={certificateHeading.type} mb="40px">
                        {certificateHeading.text}
                    </Heading>
                )}
                {sectionLoading === 'giftCerts' ? (
                    <LoadingIcon alignSelf="center" />
                ) : (
                    <GiftCertificateSelector
                        disabled={!!sectionLoading || giftCertCheckoutStep > 1}
                        flexibleGiftCertPlaceholder={flexibleGiftCertPlaceholder}
                        giftCertificates={giftCerts}
                        maxValue={maxValue}
                        minValue={minValue}
                        selectedId={selectedGiftCert?.id}
                        onSelect={onSelect}
                    />
                )}
            </Div>

            <Div display="flex" flexDirection="column">
                {giftCertCheckoutStep === 1 ? (
                    <StepButton
                        size="xl"
                        disabled={!readyToProceed || sectionLoading === 'checkout'}
                        onClick={proceedToCheckout}
                    >
                        {buttonLabelProcced}
                    </StepButton>
                ) : (
                    <StepButton size="xl" onClick={editSelectedGiftCertificate}>
                        {buttonLabelEdit}
                    </StepButton>
                )}
                {sectionLoading === 'checkout' && <LoadingIcon mt="40px" alignSelf="center" />}
            </Div>

            {giftCertCheckoutStep === 2 ? (
                <Div mt="80px">
                    <Payment displayShipping={false} paymentMethodId="adyen-drop-in" />
                </Div>
            ) : null}
        </>
    );
};

GiftCertificateContent.propTypes = {
    data: PropTypes.shape({
        content: PropTypes.object,
        gift_certificate_setup: PropTypes.object,
    }),
};

GiftCertificateContent.defaultProps = {
    data: {
        content: {},
        gift_certificate_setup: {},
    },
};

export default GiftCertificateContent;
